import { atom } from 'recoil';

export const googleApiState = atom({
	key: 'googleApiState',
	default: null,
});
